import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  Typography, Paper, Avatar, Box, Button, Grid, TextField,
  Dialog, DialogTitle, DialogContent, DialogActions, IconButton, InputAdornment,
} from "@mui/material";
import EditIcon from '@mui/icons-material/Edit';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import axios from "axios";
import DashboardLayout from "../Sidebar/DashboardLayout";
import { generateRandomPassword } from "../../commun/generatepwd";
import CustomAlert from "../../commun/CustomAlert";
import { showDeleteConfirmation } from "../../commun/deletemsg";
import DeleteIcon from '@mui/icons-material/Delete';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import './EntrepriseDetails.css';
import LoadingPopup from "../../commun/LoadingPopup";

const EntrepriseDetail = () => {
  const { id } = useParams();
  const [entreprise, setEntreprise] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [formData, setFormData] = useState({});
  const [openAddUser, setOpenAddUser] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [newUser, setNewUser] = useState({
    lastName: "", firstName: "", email: "", phone: "", motDePasse: ""
  });
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("success");

  const API_BASE = process.env.REACT_APP_API_BASE_URL;

  const fetchData = async () => {
    try {
      const res = await axios.get(`${API_BASE}/api/entreprise/details/${id}`);
      setEntreprise(res.data);
      setFormData({
        NomEntreprise: res.data.NomEntreprise || "",
        ice: res.data.ice || "",
        sector: res.data.sector || "",
        description: res.data.description || ""
      });
    } catch (err) {
      console.error("Erreur chargement :", err);
    }
  };

  useEffect(() => {
    fetchData();
  }, [id]);

  const handleLogoChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const form = new FormData();
    form.append("file", file);
    await axios.post(`${API_BASE}/api/entreprise/logo/${id}`, form);
    fetchData();
  };

  const handleSaveEntreprise = async () => {
    try {
      await axios.patch(`${API_BASE}/api/entreprise/edit/${entreprise.utilisateur._id}`, formData);
      setEditMode(false);
      fetchData();
      showMessage("Entreprise mise à jour avec succès.", "success");
    } catch (err) {
      showMessage("Erreur mise à jour entreprise", "error");
    }
  };

  const handleAddUser = async () => {
    try {
      const res = await axios.post(`${API_BASE}/api/entreprise/${id}/ajouter-utilisateur`, newUser);
      showMessage("Utilisateur ajouté avec succès. E-mail envoyé.", "success");
      setOpenAddUser(false);
      setNewUser({ lastName: "", firstName: "", email: "", phone: "", motDePasse: "" });
      fetchData();
    } catch (err) {
      showMessage("Erreur ajout utilisateur : " + err.response?.data?.message, "error");
    }
  };

const handleDeleteUser = (userId) => {
  showDeleteConfirmation({
    onConfirm: async () => {
      try {
        await axios.delete(`${API_BASE}/api/entreprise/${id}/utilisateur/${userId}`);
        showMessage("Utilisateur supprimé avec succès.", "success");
        fetchData();
      } catch (err) {
        showMessage("Erreur lors de la suppression.", "error");
      }
    },
    onCancel: () => {
      showMessage("Suppression annulée.", "info");
    }
  });
};


  const handleGeneratePassword = () => {
    const pwd = generateRandomPassword();
    setNewUser(prev => ({ ...prev, motDePasse: pwd }));
  };

  const showMessage = (message, severity = "info") => {
    setAlertMessage(message);
    setAlertSeverity(severity);
    setAlertOpen(true);
  };

  if (!entreprise) return 
      <LoadingPopup
      open={!entreprise}
      message="Chargement..."
    />;


    const handleApproval = async (userId, decision) => {
    try {
        const res = await axios.put(`${API_BASE}/api/entreprise/approve-user/${userId}`, { decision });
        fetchData();
        showMessage(res.data.message, "success");
    } catch (err) {
        showMessage("Erreur lors de l'approbation : " + err.response?.data?.message, "error");
    }
    };

const handleToggleStatus = async (userId) => {
  try {
    const res = await axios.put(`${API_BASE}/api/entreprise/toggle-user-status/${userId}`);
    showMessage(res.data.message, "success");
    fetchData(); 
  } catch (err) {
    showMessage("Erreur lors du changement de statut.", "error");
  }
};

  return (
    <DashboardLayout>
      <Paper elevation={3} sx={{ p: 4, maxWidth: 1000, margin: "auto", mt: 4 }}>
        <CustomAlert open={alertOpen} message={alertMessage} severity={alertSeverity} onClose={() => setAlertOpen(false)} />

        <Box display="flex" alignItems="center" gap={2} mb={2}>
          <Avatar src={`${API_BASE}${entreprise.logo}`} alt="logo" sx={{ width: 80, height: 80 }} />
          <Box>
            <Typography variant="h5">{entreprise.NomEntreprise}</Typography>
            <Button component="label" size="small">Changer le logo
              <input type="file" hidden onChange={handleLogoChange} />
            </Button>
          </Box>
        </Box>

        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField label="SIRET / ICE" fullWidth value={formData.ice} onChange={(e) => setFormData({ ...formData, ice: e.target.value })} disabled={!editMode} />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField label="Description" fullWidth value={formData.description} onChange={(e) => setFormData({ ...formData, description: e.target.value })} disabled={!editMode} />
          </Grid>
        </Grid>

        <Box mt={2}>
          <IconButton onClick={() => setEditMode(!editMode)}><EditIcon /></IconButton>
          {editMode && <Button onClick={handleSaveEntreprise} variant="contained">Enregistrer</Button>}
        </Box>

        <Box mt={4}>
          <Typography variant="h6" gutterBottom>👤 Utilisateur principal</Typography>
          {entreprise.utilisateur && (
            <>
              <Typography>{entreprise.utilisateur.firstName} {entreprise.utilisateur.lastName}</Typography>
              <Typography>{entreprise.utilisateur.email}</Typography>
              <Typography>{entreprise.utilisateur.phone}</Typography>
              
            </>
            
          )}
        </Box>

        <Box mt={3}>
          <Typography variant="h6" gutterBottom>👥 Autres utilisateurs liés ({entreprise.utilisateursAdditionnels?.length || 0})</Typography>
            {(entreprise.utilisateursAdditionnels || []).map((u) => (
            <Box key={u._id} mb={1} display="flex" justifyContent="space-between" alignItems="center">
                <Box>
                <Typography>{u.firstName} {u.lastName}</Typography>
                <Typography>{u.email} — {u.phone}</Typography>
                
                </Box>
                <Box display="flex" gap={1} alignItems="center">
                  {u.statut === "pending" ? (
                    <>
                      <Button
                        size="small"
                        color="success"
                        variant="contained"
                        onClick={() => handleApproval(u._id, "approve")}
                      >
                        Approuver
                      </Button>
                      <Button
                        size="small"
                        color="error"
                        variant="outlined"
                        onClick={() => handleApproval(u._id, "refuse")}
                      >
                        Refuser
                      </Button>
                    </>
                  ) : (
                    <>
                      <Button
                        size="small"
                        variant="outlined"
                        color={u.statut === "active" ? "warning" : "success"}
                        onClick={() => handleToggleStatus(u._id)}
                      >
                        {u.statut === "active" ? "Interdire" : "Activer"}
                      </Button>
                      <IconButton onClick={() => handleDeleteUser(u._id)} color="error">
                        <DeleteIcon />
                      </IconButton>
                    </>
                  )}
                </Box>


            </Box>
            ))}
          <Button onClick={() => setOpenAddUser(true)} variant="outlined" sx={{ mt: 2 }}>Ajouter un utilisateur</Button>
        </Box>
      </Paper>

      {/* Modale ajout utilisateur */}
      <Dialog open={openAddUser} onClose={() => setOpenAddUser(false)} fullWidth>
        <DialogTitle>Ajouter un utilisateur</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} mt={1}>
            <Grid item xs={12} sm={6}>
              <TextField fullWidth label="Nom" value={newUser.lastName} onChange={(e) => setNewUser({ ...newUser, lastName: e.target.value })} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField fullWidth label="Prénom" value={newUser.firstName} onChange={(e) => setNewUser({ ...newUser, firstName: e.target.value })} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField fullWidth label="Email" value={newUser.email} onChange={(e) => setNewUser({ ...newUser, email: e.target.value })} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField fullWidth label="Téléphone" value={newUser.phone} onChange={(e) => setNewUser({ ...newUser, phone: e.target.value })} />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Mot de passe"
                type={showPassword ? "text" : "password"}
                value={newUser.motDePasse}
                onChange={(e) => setNewUser({ ...newUser, motDePasse: e.target.value })}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={() => setShowPassword(!showPassword)}>
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
<Button
  onClick={handleGeneratePassword}
  size="small"
  variant="outlined"
  startIcon={<AutoFixHighIcon />}
  className="generate-password-btn"
>
  Générer mot de passe
</Button>
          </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenAddUser(false)}>Annuler</Button>
          <Button onClick={handleAddUser} variant="contained">Ajouter</Button>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
};

export default EntrepriseDetail;
